import { data } from '../../svg/Check/data';
import { makeIcon } from '../makeIcon';

export const Check = makeIcon(data, 'check', 'Check');

export default Check;
